import React, {memo, useMemo} from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Select from 'components/Select';
import TextInput from 'components/TextInput';
import Tr from 'translations/Translations';
import {connect} from 'react-redux'
import ContractorService from "services/ContractorService";


const style = theme => ({
    root: {
        '&>*:last-child': {
            flexGrow: 1,
            marginLeft: theme.spacing(2),
        }
    },
})

function NipRow(
    {
        classes,
        formikProps,
        limit,
        defaultValue,
        nipList,
        prefix,
        required = true,
        onBlur
    }) {

    const listSorted = useMemo(()=> {
        const list = [...nipList]
        list.sort((a, b) => {

            if (a === "PL" || a < b) {
                return -1;
            }
            if ( a > b) {
                return 1;
            }
            return 0;
        })
        return list;
    }, [nipList])

    return (
        <GridBlock
            wrap='nowrap'
            alignItems='baseline'
            className={classes.root}
        >
            <Select
                formikProps={formikProps}
                id='vatin.prefix'
                items={listSorted}
                label=' '
            />
            <TextInput
                id='vatin.number'
                formikProps={formikProps}
                label={Tr('nip_pesel')}
                onBlur={onBlur}
                required
            />
        </GridBlock>
    )
}

NipRow.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    nipList: state.resources[ContractorService.NIP_LIST_RESOURCE_ID]
}), {})(withStyles(style)(memo(NipRow)))